import React, { useState, } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { useNavigate } from 'react-router-dom';
import { useAuth, useSigninCheck } from 'reactfire';
import Button__Avatar from './Button__Avatar';
import {useSelector, useDispatch, } from 'react-redux';
import { signOutUser } from '../store/reducers/user';

const pages = ['Dashboard', 'Tournaments',];
const settings = ['Account', 'Logout'];




function ResponsiveAppBar(props) {
  const dispatch = useDispatch();

  const auth = useAuth()

  const [isSignedIn, setIsSignedIn] = useState(auth.currentUser); // Local signed-in state.
  console.log('signed in : ', isSignedIn)

  const navigate = useNavigate();
  console.log('current user', auth.currentUser)

  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const user = useSelector((state) => state.user);
  console.log('currentuser from auth', auth.currentUser)




  const barColor = props.barColor ? props.barColor : 'primary';
  const boxShadow = props.boxShadow ? props.boxShadow : 0;



  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const navigationHandler = (page) => {
    if (auth.currentUser) {
      if (page == 'Dashboard') {
        navigate('/dashboard')
      }
      if (page == 'Tournaments') {
        navigate('/tournaments')
      }
    }
    else {
      if (page == 'Dashboard') {
        navigate('/signin')
      }
      if (page == 'Tournaments') {
        navigate('/signin')
      }
    }
    console.log('page', page)


  }




  return (
    <AppBar position="fixed" sx={{ background: barColor, boxShadow: boxShadow }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Big Stage
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href=""
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Big Stage
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'center', }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={() => navigationHandler(page)}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page}
              </Button>
            ))}
          </Box>

          <Button__Avatar userState={isSignedIn} userStateSetter={setIsSignedIn} />
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;